import { useQuery } from '@tanstack/react-query';
import { DURATION_MS } from 'app/constants/CronTimes';
import { listRegisteredCustomersSummary } from './api';
import { ListRegisteredCustomersSummaryParams } from './types';

export const REGISTERED_CUSTOMERS_SUMMARY_PARAMS: ListRegisteredCustomersSummaryParams =
  {
    page: 1,
    limit: 8,
    order_by: 'created_at',
    order_direction: 'DESC',
  };

export const REGISTERED_CUSTOMERS_SUMMARY_QUERY_KEY = [
  'customers',
  'summary',
  REGISTERED_CUSTOMERS_SUMMARY_PARAMS,
] as const;

export function useRegisteredCustomersSummary(enabled: boolean) {
  const { data, isLoading, isError } = useQuery({
    queryKey: REGISTERED_CUSTOMERS_SUMMARY_QUERY_KEY,
    queryFn: () =>
      listRegisteredCustomersSummary(REGISTERED_CUSTOMERS_SUMMARY_PARAMS),
    enabled,
    staleTime: DURATION_MS.FIVE_MINUTES,
  });

  return {
    registeredCustomers: enabled ? data?.data || [] : [],
    /**
     * Total real de clientes cadastrados (`meta.total` da API), não o
     * tamanho da página carregada (`limit: 8`). Aditivo — consumidores que só
     * usavam `registeredCustomers`/`isLoading`/`isError` continuam intactos.
     */
    totalRegisteredCustomers: enabled
      ? data?.meta.total ?? data?.data.length ?? 0
      : 0,
    isLoading: enabled && isLoading,
    isError: enabled && isError,
  };
}
